<template>
  <span>
    <v-btn
      v-if="niveau ==='TITRE'"
      class="margin-top"
      icon
      small
      :large="false"
      @click="isHelp = !isHelp"
    >
      <v-icon color="primary">
        mdi-information
      </v-icon>
    </v-btn>

    <v-btn
      v-if="niveau ==='SOUS-TITRE'"
      icon
      small
      :large="false"
      @click="isHelp = !isHelp"
    >
      <v-icon>
        mdi-information
      </v-icon>
    </v-btn>

    <v-dialog
      v-if="isHelp"
      v-model="isHelp"
      pesistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <div class="flex-titre">
            <div class="titre">
              {{ libelleTitre }}
            </div>

            <div class="spacer" />

            <div class="bouton">
              <v-btn
                class="float-right"
                small
                :large="false"
                icon
                @click="isHelp = !isHelp"
              >
                <v-icon>
                  mdi-close
                </v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-title>

        <v-card-text v-if="page ==='HISTORIQUE'">
          <h5 class="texteAide">
            <p>Retrouvez ici l’ensemble de vos commandes livrées ces 3 derniers mois ou vos 12 dernières livraisons. </p>
            <p>
              Grâce au bouton
              <v-btn
                class="fauxBtn"
                small
                :large="false"
                outlined
              >
                Afficher plus de livraisons
              </v-btn>

              , vous pouvez remonter progressivement jusqu’à 18 mois de livraison par site d’exploitation.<br>

              Les livraisons sont affichées en ordre décroissant de date.<br>

              Pour chaque ligne de livraison vous disposez du bouton
              <v-btn
                class="fauxBtn"
                small
                :large="false"
                color="secondary"
                outlined
                disabled
              >
                Ajouter
                <v-icon>mdi-cart-outline</v-icon>
              </v-btn>
              pour saisir une nouvelle commande de l’aliment choisi. <br>

              <ul>
                <li> Pour les aliments volaille, si un plan d’alimentation est défini, le bouton

                  <v-btn
                    class="fauxBtn"
                    small
                    :large="false"
                    color="secondary"
                    outlined
                  >
                    <span class="action-btn-text ml-1">Lots &amp;<br>plans</span>
                    <v-icon>$vuetify.icons.chicken</v-icon>
                  </v-btn>

                  vous y renvoie pour éviter tout écart par rapport à ce plan.
                </li>
              </ul>

            </p>

            <p>En cliquant sur le bouton

              <v-btn
                class="fauxBtn"
                small
                :large="false"
                color="secondary"
                outlined
              >
                Ajouter
                <v-icon>mdi-cart-outline</v-icon>
              </v-btn>

              , vous affichez le formulaire de saisie de commande avec les champs déjà préremplis à partir des informations de la ligne de commande choisie, que vous pouvez modifier à votre convenance avant de l’ajouter à votre panier.
            </p>

            <p>Le bouton
              <v-btn
                class="fauxBtn"
                small
                :rounded="false"
                :large="false"
                color="secondary white--text"
              >
                Duplication
                <v-icon>mdi-cart-plus</v-icon>
              </v-btn>

              permet de renouveler rapidement une commande. Quand vous cliquez sur ce bouton, vous pouvez sélectionner les articles à ajouter à votre panier.<br>

              Puis en cliquant sur le bouton
              <v-btn
                class="fauxBtn"
                small
                :large="false"
                outlined
              >
                Valider la sélection
              </v-btn>, vous serez amené à saisir vos dates de livraison souhaitées.
            </p>

            <p>Un message d’alerte vous informe si un silo est utilisé plusieurs fois pour une même date de livraison.</p>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='ALIMENTS'">
          <h5 class="texteAide">
            <p>
              Retrouvez ici la liste des aliments classés par filière que vous pouvez commander sur notre site internet.<br>
              Pour chaque aliment, utilisez le bouton
              <v-btn
                class="fauxBtn"
                small
                :large="false"
                color="secondary"
                outlined
              >
                Ajouter
                <v-icon>mdi-cart-outline</v-icon>
              </v-btn>

              pour saisir une nouvelle ligne de commande, à l’exception de certains minéraux qui ne peuvent être commandés seuls.<br>

              Pour les aliments volailles, utilisez le bouton
              <v-btn
                class="fauxBtn"
                small
                :large="false"
                color="secondary"
                outlined
              >
                <span class="action-btn-text ml-1">Lots &amp;<br>plans</span>
                <v-icon>$vuetify.icons.chicken</v-icon>
              </v-btn>

              si vous avez un plan d’alimentation enregistré.
            </p>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='CONTRATS'">
          <h5 class="texteAide">
            <p>
              Retrouvez ici l’ensemble de vos contrats aliments et céréales actuellement saisis, en cours de validité ou à venir.<br>
              <br>
              Pour chaque contrat en cours de validité sur lequel il y a un reste à consommer, vous pouvez saisir une nouvelle commande par le menu "Historique" ou "Aliments".<br>
              Pour solder les contrats de vente à terme, il faut que la livraison soit effective avant le dernier jour du contrat.<br>
            </p>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='LOTS-PLAN'">
          <h5 class="texteAide">
            <p>
              Retrouvez ici vos plans d’alimentation par lot de volaille. <br>
              Le bouton
              <v-btn
                class="fauxBtn"
                small
                :large="false"
                color="secondary"
              >
                Voir
              </v-btn>
              vous permet d’afficher le plan d’alimentation défini et d’accéder à la prise de commande pour ces aliments.
            </p>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='DETAIL-LOT'">
          <h5 class="texteAide">
            <p>
              Retrouvez ici le détail du plan d'alimentation, trié par tranche d'âge.<br>

              La quantité commandée correspond à l’ensemble de vos commandes (livrées ou non) pour cette tranche d’âge et ce lot de volaille, ainsi que la quantité en attente dans votre panier. <br>
              Elle est mise en regard avec la quantité estimée à commander calculée à partir de la consommation indiquée et le nombre d’individus constituant le lot.<br>

              Pour vous accompagner au mieux dans le respect de votre plan d'alimentation, vous ne pouvez commander un aliment d'une tranche si le précédent aliment est soldé. Le tonnage des tranches est calculé par le nombre d'animaux pour le lot et la consommation moyenne de l'aliment

            </p>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='COMMANDE'">
          <h5 class="texteAide">
            <p>
              Vous pouvez suivre vos commandes d’aliments dans ce menu, classé dans l’ordre du traitement de la commande : <br>
              <ul>
                <li>Commande en attente de validation</li>
                <li>Commande valorisée</li>
                <li>Commande en logistique </li>
                <li>Commande livrée</li>
                <li>Commande facturée </li>
                <li>Commande supprimée</li>
              </ul>

            </p>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='AJOUT-MODIF-PANIER'">
          <h5 class="texteAide">
            <p>
              Retrouvez ici l’ensemble des informations de votre ligne de commande.<br>
              Veillez à l’exactitude de ces informations avant de valider votre commande.
            </p>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='DUPLICATION_DERNIERE_COMMANDE'">
          <h5 class="texteAide">
            <p>
              La duplication de dernière commande ne peut pas être utilisée pour l’ensemble des articles.<br>
              <br>Pour commander des aliments à destination des volailles, il est nécessaire d’utiliser le menu “plan d’alimentation”.<br>
              <br>La liste des articles commandables sur le site est disponible dans le menu “aliments”.

            </p>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='SUPPLEMENTATION'">
          <h5 class="texteAide">
            <p>
              <ul>
                <li> Les boutons “Ajouter une supplémentation” et “Ajouter un minéral” ne sont visibles et actifs que s’il existe des supplémentations ou incorporations disponibles pour l’article. </li>
                <li>La liste des supplémentations/incorporations possibles est mise à jour en fonction de l’article choisi et des supplémentations /incorporations déjà sélectionnées ou supprimées.</li>
                <li>Pour les supplémentations qui ont un pourcentage déjà défini, il n’y a pas de champ affiché pour le pourcentage. </li>
              </ul>
            </p>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='QUANTITE'">
          <h5 class="texteAide">
            <b>Contrainte liée au produit</b>
            <ul>
              <li>Chaque produit possède un minima et un maxima de commande</li>
              <li>Pour les aliments simples
                <ul>
                  <li>Sans contrat de vente à terme : maximum 15 t</li>
                  <li>Avec contrat de vente à terme : maximum de 29 t</li>
                </ul>
              </li>
            </ul>
            <b>Contrainte liée au mode de livraison</b>
            <ul>
              <li>En mode camion vis et soufflerie (hors petit camion), la quantité maximale est de 27 t. </li>
              <li>En mode petit camion, la quantité maximale est de 17 t.</li>
              <li>En livraison benne, la quantité doit être supérieure ou égale à 25 t.
                <ul>
                  <li>En benne simple, la quantité maximale transportée est de 29 t</li>
                  <li>En benne à fond mouvant, elle est de 27 t</li>
                </ul>
              </li>
            </ul>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='STOCKAGE'">
          <h5 class="texteAide">
            <b>Adresse de livraison</b>
            <ul>
              <li>L'adresse de livraison est obligatoire. Vous pouvez la modifier si vous avez plusieurs sites de livraison (sauf commandes dans le cadre d'un plan d'alimentation).</li>
            </ul>
            <b>Lieu de stockage</b>
            <ul>
              <li>Le 1er de lieu de stockage est obligatoire. Vous pouvez éventuellement mentionner jusqu'à 2 lieux supplémentaires. </li>
              <li>Un message/ d’alerte vous informe si un des lieux de stockage de la ligne est déjà mentionné dans d’autres lignes de commande de votre panier pour une même date de livraison. </li>
            </ul>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='LIVRAISON'">
          <h5 class="texteAide">
            <b>Période de livraison</b>
            <ul>
              <li>Le calendrier des dates de livraison s’adapte aux jours d’ouverture de l’usine.Suivant l’heure de votre commande, il peut être possible ou non de commander pour le lendemain. </li>

              <li>Par défaut, les dates au plus tôt et au plus tard de livraison sont renseignées automatiquement mais vous pouvez toujours les modifier. Une option vous permet de spécifier des plages horaires de livraison. </li>
              <li>Cependant, dans certains cas, il est obligatoire de conserver une période de livraison de deux jours ou plus (ex: aliment cheval, mode de livraison en petit camion). Un message vous alerte si la période n’est pas respectée. </li>
              <li>L'heure pivot pour pouvoir être livré le lendemain est fixé à 10h du matin. Si vous vous connectez après 10h, vous ne pourrez plus saisir de livraison pour le lendemain. </li>
            </ul>

            <b>Mode de livraison</b><br>
            Vous devez nécessairement choisir entre vis, soufflerie, benne ou enlèvement usine.
            <ul>
              <li>En mode soufflerie ou vis : possibilité de choisir petit camion (porteur) ou non. </li>
              <li>En camion benne, possibilité de choisir à fond mouvant ou non. </li>
              <li>En enlèvement usine, pas d'option supplémentaire. </li>
            </ul>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='COMMENTAIRE'">
          <h5 class="texteAide">
            <p>
              Le bouton “Ajouter un commentaire” vous permet de saisir un commentaire libre.
            </p>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='COMMENTAIRE_PANIER'">
          <h5 class="texteAide">
            <p>
              Le bouton “Ajouter un commentaire” vous permet de laisser un commentaire prédéfini (case à cocher) ou de saisir un commentaire libre destiné uniquement au service logistique. Cependant, les indications relatives aux dates de livraison ne seront pas prises en compte. Pour toute interrogation sur votre commande, contactez directement par téléphone le service commandes.
            </p>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='VALID-PANIER'">
          <h5 class="texteAide">
            <p>
              Retrouvez ici l’ensemble des lignes de votre commande, en attente de validation. Veillez à l’exactitude de ces informations avant de valider votre commande. </p>
            <ul>
              <li>Pour chaque ligne de commande, vous pouvez modifier les informations saisies ou la supprimer. </li>
              <li>Le poids total du panier est affiché en fin de commande pour information.</li>
              <li>Si vous validez votre panier, vous serez amené ensuite à choisir le mode de règlement. </li>
              <li>Vous pouvez aussi vider tout votre panier : une confirmation vous sera demandée.
                Vous êtes informés si votre panier contient une ou plusieurs lignes de commandes à livrer dans les mêmes lieux de stockage sur des périodes de livraison se chevauchant, pour une même espèce ou non.
              </li>
              <li>Si vous validez votre commande trop tardivement, certaines dates de livraison peuvent ne plus être acceptées.
              </li>
            </ul>

          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='VALID-COMMANDE'">
          <h5 class="texteAide">
            <p>
              Retrouvez ici les informations sur les modes de paiement pour chacune de vos lignes de commande.
              <br>Vous pouvez modifier vos modes de règlement dans la limite de vos autorisations, de même pour vos comptes bancaires si vous avez plusieurs autorisations de prélèvement.
              <br>Veillez à l’exactitude de ces informations avant de finaliser votre commande.
            </p>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='SAS-HORAIRE_COMMANDE-HEURE_PIVOT'">
          <h5 class="texteAide">
            <p>
              L'heure pivot détermine l'heure à partir de laquelle on ne peut plus commander pour le lendemain.
              <br>Par défaut : 10h

            </p>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='SAS-HORAIRE_COMMANDE-DELAIS_HEURE_PIVOT'">
          <h5 class="texteAide">
            <p>
              Toute personne se connectant au plus tard à 9h59 (par défaut) bénéficie d’un délai supplémentaire.
              <br>Par défaut : 0h30

            </p>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='SAS-DELAIS_COMMANDE-ECART_DATE'">
          <h5 class="texteAide">
            <p>
              Un message de contrôle s’affiche si la date au plus tard est supérieur à 5 jours ouvrés par défaut de la date au plus tôt.
            </p>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='SAS-MODE_CAMION_QTE-VIS_MAX'">
          <h5 class="texteAide">
            <p>
              Le mini et maxi pour le mode camion permet de ne pas surcharger les camions en logistique.
              <br>Par défaut :
              <br>- Les camions vis et soufflerie : maxi de 27 T
              <br>- Les petits camions vis et soufflerie : maxi de 17 T
              <br>- La benne : maxi de 29 T et mini de 25 T
              <br>- Le fond mouvant : maxi de 27 T et mini de 25 T
            </p>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='SAS-COMMANDE_QTE-QTE_MAX_MINERAL'">
          <h5 class="texteAide">
            <p>
              Le minéral en incorporation est maximum de 15% par défaut. </p>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='CDE-5-DELAI_ALERTE_FERIES'">
          <h5 class="texteAide">
            <p>
              La bannière des jours fériés s’affiche automatiquement 15 jours (par défaut) avant le jour J si celui-ci est ouvré.
            </p>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='SAS-MODE_CAMION_DELAI_LIVR-FOND'">
          <h5 class="texteAide">
            <p>
              Le délai pour une benne est de 48H par défaut.
              <br>Le délai pour une benne fond mouvant est de 72H par défaut.
            </p>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='SAS-DELAIS_COMMANDE-DELAIS_MAX'">
          <h5 class="texteAide">
            <p>
              Par défaut, l’adhérent peut au maximum commander sur 1 mois jour de commande.
            </p>
          </h5>
        </v-card-text>

        <v-card-text v-if="page ==='SAS-DELAIS_COMMANDE-DELAIS_ALERTE'">
          <h5 class="texteAide">
            <p>
              Le délai si une commande est passé au plus tard à 5 jours ouvrés de sa date de commande, un message d’alerte s’affiche par défaut.
            </p>
          </h5>
        </v-card-text>

      </v-card>
    </v-dialog>
  </span>
</template>

<script>
export default {
  name: 'CardsHelp',
  props: {
    page: {
      type: String,
      required: true
    },
    niveau: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isHelp: false

  }),
  computed: {
    libelleTitre () {
      if (this.page === null) {
        return '';
      }
      switch (this.page) {
        case 'HISTORIQUE':
          return 'Historique des livraisons';
        case 'ALIMENTS':
          return 'Aliments';
        case 'CONTRATS':
          return 'Contrats';
        case 'LOTS-PLANS':
          return 'Lots et plans';
        case 'DETAIL-LOT':
          return 'Détail du lot';
        case 'COMMANDE':
          return 'Commande';
        case 'AJOUT-MODIF-PANIER':
          return 'Ajout et modification du panier';
        case 'DUPLICATION_DERNIERE_COMMANDE':
          return 'Duplication de la dernière commande';
        case 'SUPPLEMENTATION':
          return 'Produit et supplémentations liées';
        case 'QUANTITE':
          return 'Quantité';
        case 'STOCKAGE':
          return 'Stockage';
        case 'LIVRAISON':
          return 'Livraison';
        case 'COMMENTAIRE':
          return 'Commentaire';
        case 'COMMENTAIRE_PANIER':
          return 'Commentaire';
        case 'VALID-PANIER':
          return 'Validation du panier';
        case 'VALID-COMMANDE':
          return 'Validation de la commande';
        case 'SAS-HORAIRE_COMMANDE-HEURE_PIVOT':
          return 'Heure pivot';
        case 'SAS-HORAIRE_COMMANDE-DELAIS_HEURE_PIVOT':
          return 'Délai supplémentaire pour l heure pivot';
        case 'SAS-DELAIS_COMMANDE-ECART_DATE':
          return 'Ecart maxi entre les deux dates de livraison';
        case 'SAS-MODE_CAMION_QTE-VIS_MAX':
          return 'Tonnage camion';
        case 'SAS-COMMANDE_QTE-QTE_MAX_MINERAL':
          return 'Minéral en incorporation';
        case 'CDE-5-DELAI_ALERTE_FERIES':
          return 'Jour férié';
        case 'SAS-MODE_CAMION_DELAI_LIVR-FOND':
          return 'Délai de livraison';
        case 'SAS-DELAIS_COMMANDE-DELAIS_MAX':
          return 'Délai maximum de commande';
        case 'SAS-DELAIS_COMMANDE-DELAIS_ALERTE':
          return 'Délai alerte de commande';
      }
      return '';
    }

  }
};
</script>
<style lang="scss" scoped>
.fauxBtn {
  cursor: default;
}
.texteAide {
  cursor: default;
}

.flex-titre {
  display: flex;
  flex-direction: row;
  width: 100%;
  .spacer {
    flex-grow: 1;
  }
}
</style>
